/**
 * Class used to handle common paginated requests from our backend APIs
 */
export class PagedCollectionParams {
  readonly offset: number = 0;
  readonly limit: number;
  readonly sortExpression: string;
  readonly sortDirection: '' | 'asc' | 'desc';
  readonly query: string;

  constructor(params: {
    limit: number;
    offset: number;
    query?: string;
    sortDirection?: '' | 'asc' | 'desc';
    sortExpression?: string;
  }) {
    this.offset = params.offset;
    this.limit = params.limit;
    this.sortExpression = params.sortExpression ?? '';
    this.sortDirection = params.sortDirection ?? '';
    this.query = params.query ?? '';
  }

  /**
   * @returns URLSearchParams
   */
  protected generateParams() {
    const params = new URLSearchParams();

    params.append('offset', String(this.offset));
    params.append('limit', String(this.limit));

    if (this.sortDirection && this.sortExpression) {
      params.append('sortExpression', this.sortExpression);
      params.append('sortDirection', this.sortDirection);
    }

    if (this.query) {
      params.append('query', this.query);
    }

    return params;
  }

  /**
   * Returns string properly formatted for URL paramters
   */
  get urlParams() {
    const params = this.generateParams();

    return params.toString();
  }

  get params() {
    return this.generateParams();
  }
}
